import { PossibleInvoicePaymentLineItems } from "../types/PossibleInvoicePaymentLineItems"
import { Trial as InvoiceAssocTrial } from "../payment-line-item-assoc/invoice-payment-line-item-assoc.component";
import { PaymentLineItemInvoiceAssocUpdates } from "../types/PaymentLineItemInvoiceAssocUpdates";

export function MapApiToAssoc(possiblePaymentLineItems: PossibleInvoicePaymentLineItems[], invoiceId: number): InvoiceAssocTrial[] {
  let assocData: InvoiceAssocTrial[] = [];

  possiblePaymentLineItems.forEach((paymentLineItem) => {
    const itemToAdd: InvoiceAssocTrial = {
      BudgetYears: [],
      Currency: paymentLineItem.PaymentLineItem.CurrencyName,
      IsCommercial: paymentLineItem.PaymentLineItem.IsCommercial,
      Status: paymentLineItem.PaymentLineItem.Status,
      Title: paymentLineItem.PaymentLineItem.ShortTitle,
      TrialNumber: paymentLineItem.PaymentLineItem.Number,
      RestrictionStatus: paymentLineItem.PaymentLineItem.RestrictionStatus,
      SourceSystemLink: paymentLineItem.PaymentLineItem.SourceSystemLink,
      ItemType: paymentLineItem.PaymentLineItem.ItemType
    };

    paymentLineItem.VendorPaymentLineItemAssocDtos.forEach((vendorAssoc) => {
      let budgetYear = itemToAdd.BudgetYears.find((a) => a.Year == vendorAssoc.BudgetYear);
      if (budgetYear === undefined) {
        budgetYear = {
          Objectives: [],
          Year: vendorAssoc.BudgetYear
        };
        itemToAdd.BudgetYears.push(budgetYear);
      }

      budgetYear.Objectives.push({
        Invoices: [],
        ObjectiveName: vendorAssoc.ObjectiveName,
        QuotedAmount: vendorAssoc.QuotedAmount,
        PaymentLineItemVendorAssocId: vendorAssoc.Id,
        Currency: paymentLineItem.PaymentLineItem.CurrencyName
      });
    });

    // now add in any invoice assoc records
    paymentLineItem.PaymentLineItemInvoiceAssocDtos.forEach((invoiceAssoc) => {
      itemToAdd.BudgetYears.forEach((budgetYear) => {
        budgetYear.Objectives.forEach((objective) => {
          if (invoiceAssoc.PaymentLineItemVendorAssocId == objective.PaymentLineItemVendorAssocId) {
            const invoiceLookup = paymentLineItem.LookupInvoice.find((a) => a.InvoiceId == invoiceAssoc.InvoiceId);
            objective.Invoices.push({
              Amount: invoiceAssoc.InvoiceAmount,
              Editable: invoiceAssoc.InvoiceId == invoiceId,
              InvoiceId: invoiceAssoc.InvoiceId,
              Name: invoiceLookup != null ? invoiceLookup.InvoiceNumber : "-unknown-",
              PaymentLineItemInvoiceAssocId: invoiceAssoc.Id,
              IsCurrentInvoice: invoiceAssoc.InvoiceId == invoiceId
            });
          }
        })
      })
    })

    assocData.push(itemToAdd);
  });

  return assocData.sort((a, b) => (a.ItemType + a.TrialNumber) < (b.ItemType + b.TrialNumber) ? -1 : (a.ItemType + a.TrialNumber) > (b.ItemType + b.TrialNumber) ? 1 : 0);
}

export function MapAssocToUpdates(assocData: Array<InvoiceAssocTrial>, invoiceId: number): PaymentLineItemInvoiceAssocUpdates[] {
  const updates: PaymentLineItemInvoiceAssocUpdates[] = [];

  assocData.forEach((assoc) => {
    assoc.BudgetYears.forEach((budgetYear) => {
      budgetYear.Objectives.forEach((objective) => {
        objective.Invoices.filter((invoice) => invoice.InvoiceId === invoiceId).forEach((invoice) => {
          updates.push({
            InvoiceAmount: invoice.Amount,
            PaymentLineItemVendorAssocId: objective.PaymentLineItemVendorAssocId,
            PaymentLineItemInvoiceAssocId: invoice.PaymentLineItemInvoiceAssocId
          })
        })
      })
    })
  })

  return updates;
}
